


































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import HTTP from '@/plugins/axios'
import ErrorMixin from '@/mixins/Error'
import { TextMSGDTO } from '@/interfaces/DialogNewRolUsuario.interface'
import moment from 'moment'
moment.locale('es-MX')

@Component({
  mixins: [
    ErrorMixin
  ]
})
export default class ViewConfiguracion extends Vue {
  private name: string = 'ViewConfiguracion'
  private isDev: boolean = true
  private isProd: boolean = false
  private showPass: boolean = false
  private menuBloquearOXXO: boolean = false
  private menuBloquearSHOP: boolean = false
  private Config: any = {
    isDev: true,
    devPublicKey: '',
    devPrivateKey: '',
    prodPublicKey: '',
    prodPrivateKey: '',
    emailService: 'gmail',
    emailAuthUser: '',
    emailAuthPass: '',
    blockoxxo: new Date().toISOString().substr(0, 10),
    blockshop: new Date().toISOString().substr(0, 10)
  }

  private textMSG: TextMSGDTO = {
    success: {
      text: 'Configuración Actualizada.',
      color: 'success'
    },
    update: {
      text: 'Configuración Actualizada.',
      color: 'info'
    },
    fail: {
      text: 'Error al guardar:',
      color: 'error'
    },
  }

  private emailOptions: string[] = [
    'gmail', 'sendgrid'
  ]

  @Watch('isDev')
  private watchIsDev (v: boolean) {
    if (v) {
      this.isProd = false
    }
  }

  @Watch('isProd')
  private watchIsProd (v: boolean) {
    if (v) {
      this.isDev = false
    }
  }

  private sConfig (item: any) {
    item.isDev = this.isDev
    console.log('sConfig :: ', item)
    HTTP.post('config/', item)
      .then((response) => {
        console.log('sConfig :: response :: ', response.data)
        this.gConfig()
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.success.text,
          color: this.textMSG.success.color,
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('sConfig :: catch :: ', e.response.data)
        // @ts-ignore: Unreachable code error
        this.textError = this.getError(e.response.data.message)
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.fail.text,
          color: this.textMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }

  private gConfig () {
    HTTP.get('config/')
      .then((response) => {
        console.log('gConfig :: response :: ', response.data)
        if (response.data.success) {
          this.Config = response.data.info
          this.Config.blockoxxo = this.Config.blockoxxo.substr(0, 10)
          this.Config.blockshop = this.Config.blockshop.substr(0, 10)
          if (this.Config.isDev) {
            this.isDev = true
            this.isProd = false
          } else {
            this.isDev = false
            this.isProd = true
          }
        }
      })
      .catch((e) => {
        console.log('gConfig :: catch :: ', e.response.data)
      })
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    this.gConfig()
  }
}
